import { Component, OnInit } from '@angular/core';

import { getObjectiveMarriageSelectors } from 'src/app/modules/objective/store/objective.selectors';
import { IObjectivesFormState } from 'src/app/modules/objective/store/objective.state';

import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { formatDate } from 'src/app/utils/format-date';
import { formatCurrency } from 'src/app/utils/format-currency';

@Component({
  selector: 'app-pdf-marriage',
  templateUrl: './pdf-marriage.component.html',
  styleUrls: ['./pdf-marriage.component.scss'],
})
export class PdfMarriageComponent implements OnInit {
  dataStoreMarriage$: Observable<any>;
  dataStoreMarriage: IObjectivesFormState;
  intendDate: any;
  minInvestimentFormated: string;
  maxInvestimentFormated: string;

  constructor(private store: Store) {}

  getState() {
    this.dataStoreMarriage$ = this.store.select(getObjectiveMarriageSelectors);
    this.dataStoreMarriage$.subscribe((value) => {
      this.dataStoreMarriage = {
        ...(this.dataStoreMarriage = value),
      };
    });

    this.intendDate = this.dataStoreMarriage.date;
    if (this.intendDate) {
      this.intendDate = formatDate(this.intendDate);
    } else {
      this.intendDate = 'data não especificada!';
    }

    this.minInvestimentFormated = formatCurrency(
      this.dataStoreMarriage.minimumInvestment
    );
    this.maxInvestimentFormated = formatCurrency(
      this.dataStoreMarriage.maximumInvestment
    );
  }

  ngOnInit(): void {
    this.getState();
  }

}
